import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

// COMPONENTS
import Wrapper from "../../../../components/helpers/Wrapper"
import Tab from "../../../../components/ui/Tab";

// STORAGE
import FullPageExportContext from "../../../../store/fullPageExportContext";

// PAGES
import CampaignFacebookOverall, { CampaignFacebookOverallCoke } from "./CampaignFacebookOverall";
import CampaignFacebookVideo from "./CampaignFacebookVideo";

// UTILS
import { IAEvent_Primary_Tab_Visit } from "../../../../utils/IAEvents";

// CONSTANT
import { COKE_COMPANY_ID, HALEON_COMPANY_ID, IDFC_COMPANY_ID, OLX_AUTOS_COMPANY_ID } from "../../../../constants/constants";

const CampaignFacebook = ({ platformData }) => {
    const { exportSummary, setExportPageName } = useContext(FullPageExportContext);

    // USER DATA
    const userData = useSelector((state) => state.userData.user);
    let companyID = userData === undefined || userData === [] ? "" :
        userData.company === undefined || userData.company === [] ? "" :
            userData.company.id === undefined || userData.company.id === null ? "" :
                userData.company.id;

    let tabData = [];

    if (companyID === COKE_COMPANY_ID || companyID === HALEON_COMPANY_ID || companyID === IDFC_COMPANY_ID || companyID === OLX_AUTOS_COMPANY_ID) {
        tabData = ["Overall"];
    } else {
        tabData = ["Overall", "Video"];
    }

    let facebookOverall = [];
    if (companyID === COKE_COMPANY_ID) {
        facebookOverall = <CampaignFacebookOverallCoke topCardData={{ Summary: exportSummary, "PlatformCards_Platform Cards": platformData }} />
    }
    else {
        facebookOverall = <CampaignFacebookOverall topCardData={{ Summary: exportSummary, "PlatformCards_Platform Cards": platformData }} />
    }

    const [selectedTab, setSelectedTab] = useState(tabData[0]);

    const handleCallback = (event) => {
        if (selectedTab !== event) {
            setSelectedTab(event);
        }
        IAEvent_Primary_Tab_Visit("Marketing Intelligence", "Campaign", "Facebook", event)
    };

    useEffect(() => {
        setExportPageName("Campaign Facebook " + selectedTab)
    }, [selectedTab])

    return (
        <Wrapper>
            <div className="grid grid_margin_bottom">
                <Tab
                    varient={"primary"}
                    tabData={tabData}
                    activeTab={selectedTab}
                    handleCallback={(event) => handleCallback(event)}
                />
            </div>
            {selectedTab.toLowerCase() === "overall" && facebookOverall}
            {selectedTab.toLowerCase() === "video" && <CampaignFacebookVideo topCardData={{ Summary: exportSummary, "PlatformCards_Platform Cards": platformData }} />}
        </Wrapper>
    )
}

export default CampaignFacebook;